import { useContext} from "react";
import { ThemeContext } from "../../context/ThemeContext";

function CardFit(props){
    const theme = useContext(ThemeContext);
    const {dark} = theme;
    return <div className={`flex  px-8 py-6 ${dark ? "bg-neutral-900" : "bg-white"} rounded-lg w-1/4 h-max mb-10 justify-center items-center shadow-md`}>{props.children}</div>
}

export default CardFit;